<form novalidate #setupForm="ngForm">
  <div class="setup-container">
    <div class="section-container advanced-setup-margin">
      <div class="section-label identity">Identity</div>
      <div class="identity-row">
        <div class="section-data">
          <nrwl-test-identity
            [testName]="testName"
            [customer]="customerName"
            [technician]="technicianName"
            [contact]="contact"
            [email]="email"
            [phone]="phone"
            [technicianId]="technicianId"
            [comments]="comments"
            [editMode]="editMode || cloneMode"
            (updateTestIdentity)="updateTestIdentity($event)"
          ></nrwl-test-identity>
        </div>
        <div class="section-data advanced-setup-link" (click)="onChangeTestSetup()">
          Show {{ isAdvancedSetup ? 'Basic ' : 'Advanced ' }}Setup
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="section-label">Test Type</div>
      <div class="section-data">
        <div class="group">
          <div class="label">Test mode</div>
          <mat-select
            name="testMode"
            class="option-list width-200"
            #testModeInput="ngModel"
            [disabled]="editMode"
            [(ngModel)]="setupFormField.testMode"
            (selectionChange)="onTestModeChange()"
          >
            <mat-option *ngFor="let mode of testModes" [value]="mode.value">
              {{ mode.name }}</mat-option
            >
          </mat-select>
        </div>
        <div class="group">
          <div class="label">Layer to test</div>
          <mat-select
            name="layerToTest"
            class="option-list"
            #layerToTestInput="ngModel"
            [(ngModel)]="setupFormField.layerToTest"
            (selectionChange)="onLayerChange()"
          >
            <mat-option *ngFor="let layers of layerTypes" [value]="layers.value">{{
              layers.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">IP Address Type</div>
          <mat-select
            name="ipAddrType"
            class="option-list"
            #ipAddrTypeInput="ngModel"
            [(ngModel)]="setupFormField.ipAddrType"
            (selectionChange)="onIpAddressTypeChange()"
          >
            <mat-option *ngFor="let ipTypes of ipAddressTypes" [value]="ipTypes.value">{{
              ipTypes.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">Stream rate convention</div>
          <mat-select
            name="streamRateConvention"
            #streamRateInpute="ngModel"
            class="option-list"
            [(ngModel)]="setupFormField.streamRateConvention"
            (selectionChange)="onStreamRateConventionChange()"
          >
            <mat-option *ngFor="let conven of streamRateTypes" [value]="conven.value">{{
              conven.name
            }}</mat-option>
          </mat-select>
        </div>
        <div class="group">
          <div class="label">Max Test Duration (hh:mm:ss) *</div>
          <input
            matInput
            autocomplete="off"
            type="text"
            class="input-data width-60"
            name="maxTestDuration"
            #maxTestDurationInput="ngModel"
            [(ngModel)]="setupFormField.maxTestDuration"
            placeholder="HH:MM:SS"
            (ngModelChange)="maxTestDurationChange()"
            [pattern]="validTestDurationRegex"
            (input)="reformatTestDuration($event)"
            maxlength="8"
            required
          />
          <div
            class="error"
            *ngIf="
              maxTestDurationInput.invalid &&
              (maxTestDurationInput.dirty || maxTestDurationInput.touched)
            "
          >
            <mat-error *ngIf="maxTestDurationInput?.errors?.required"
              >Duration is required</mat-error
            >
            <mat-error *ngIf="maxTestDurationInput.errors?.pattern"
              >Invalid test duration</mat-error
            >
          </div>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="section-label">Throughput</div>
      <div class="enable-section">
        <div class="slide-btn">
          <mat-slide-toggle
            #throughputToggleElement
            name="throughput"
            [checked]="setupFormField.throughput"
            class="enable-row"
            color="primary"
            (change)="throughputToggleChange(throughputToggleElement)"
          >
          </mat-slide-toggle>
          <div class="toggle-text">
            <div class="section-label">
              {{ setupFormField.throughput ? 'On' : 'Off' }}
            </div>
          </div>
        </div>
        <div class="section-data" *ngIf="setupFormField.throughput">
          <div class="group">
            <div class="label">Duration (5-600)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-45 float-left"
              name="throughputDuration"
              #throughputDurationInput="ngModel"
              [(ngModel)]="setupFormField.throughputDuration"
              (ngModelChange)="throughputDurationChange()"
              min="5"
              max="600"
              required
            />
            <spa class="unit-label vert-text-mid">sec/frame</spa>
            <div
              class="error clr-float"
              *ngIf="
                throughputDurationInput.invalid &&
                (throughputDurationInput.dirty || throughputDurationInput.touched)
              "
            >
              <mat-error *ngIf="throughputDurationInput?.errors?.required"
                >Duration is required</mat-error
              >
              <mat-error
                *ngIf="throughputDurationInput.errors?.min || throughputDurationInput.errors?.max"
              >
                Value should be 5 to 600</mat-error
              >
            </div>
          </div>
          <div class="group">
            <div class="label">Frame Loss Tolerance (0-5)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-45 float-left"
              name="throughputFrameLossTolerance"
              #throughputFrameLossToleranceInput="ngModel"
              [(ngModel)]="setupFormField.throughputFrameLossTolerance"
              (ngModelChange)="throughputFrameLossToleranceChange()"
              min="0"
              max="5"
              required
            />
            <spa class="unit-label vert-text-mid">%</spa>
            <div
              class="error clr-float"
              *ngIf="
                throughputFrameLossToleranceInput.invalid &&
                (throughputFrameLossToleranceInput.dirty ||
                  throughputFrameLossToleranceInput.touched)
              "
            >
              <mat-error *ngIf="throughputFrameLossToleranceInput?.errors?.required"
                >Frame Loss Tolerance is required</mat-error
              >
              <mat-error
                *ngIf="
                  throughputFrameLossToleranceInput.errors?.min ||
                  throughputFrameLossToleranceInput.errors?.max
                "
              >
                Value should be 0 to 5</mat-error
              >
            </div>
          </div>
          <div class="group">
            <div class="label">Stop Overall Test On Failure</div>
            <mat-select
              class="option-list width-75"
              #throughputStopOverallTestOnFailureInput="ngModel"
              [(ngModel)]="setupFormField.throughputStopOverallTestOnFailure"
              name="throughputStopOverallTestOnFailure"
              (selectionChange)="throughputStopOverallTestOnFailureChange()"
              required
            >
              <mat-option *ngFor="let item of throughputStopOveralTestTypes" [value]="item.value">{{
                item.name
              }}</mat-option>
            </mat-select>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container" *ngIf="setupFormField.throughput && isAdvancedSetup">
      <div class="section-label"></div>
      <div class="enable-section">
        <div class="section-data">
          <div class="group">
            <div class="label">Starting Utilization (10-110)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-45 float-left"
              name="throughputStartingUtilization"
              #throughputStartingUtilizationInput="ngModel"
              [(ngModel)]="setupFormField.throughputStartingUtilization"
              (ngModelChange)="throughputStartingUtilizationChange()"
              min="10"
              max="110"
              required
            />
            <spa class="unit-label vert-text-mid">% of CIR</spa>
            <div
              class="error clr-float"
              *ngIf="
                throughputStartingUtilizationInput.invalid &&
                (throughputStartingUtilizationInput.dirty ||
                  throughputStartingUtilizationInput.touched)
              "
            >
              <mat-error *ngIf="throughputStartingUtilizationInput?.errors?.required"
                >Starting utilization is required</mat-error
              >
              <mat-error
                *ngIf="
                  throughputStartingUtilizationInput.errors?.min ||
                  throughputStartingUtilizationInput.errors?.max
                "
              >
                Value should be 10 to 110</mat-error
              >
            </div>
          </div>
          <div class="group">
            <div class="label">Min Utilization to Pass (0-110)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-45 float-left"
              name="throughputMinUtilization"
              #throughputMinUtilizationInput="ngModel"
              [(ngModel)]="setupFormField.throughputMinUtilization"
              (ngModelChange)="throughputMinUtilizationChange()"
              min="0"
              max="110"
              required
            />
            <spa class="unit-label vert-text-mid">% of CIR</spa>
            <div
              class="error clr-float"
              *ngIf="
                throughputMinUtilizationInput.invalid &&
                (throughputMinUtilizationInput.dirty || throughputMinUtilizationInput.touched)
              "
            >
              <mat-error *ngIf="throughputMinUtilizationInput?.errors?.required"
                >Min utilization to pass is required</mat-error
              >
              <mat-error
                *ngIf="
                  throughputMinUtilizationInput.errors?.min ||
                  throughputMinUtilizationInput.errors?.max
                "
              >
                Value should be 0 to 110</mat-error
              >
            </div>
          </div>
          <div class="group">
            <div class="label">Max Utilization to Pass (0-110)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-45 float-left"
              name="throughputMaxUtilization"
              #throughputMaxUtilizationInput="ngModel"
              [(ngModel)]="setupFormField.throughputMaxUtilization"
              (ngModelChange)="throughputMaxUtilizationChange()"
              min="0"
              max="110"
              required
            />
            <spa class="unit-label vert-text-mid">% of CIR</spa>
            <div
              class="error clr-float"
              *ngIf="
                throughputMaxUtilizationInput.invalid &&
                (throughputMaxUtilizationInput.dirty || throughputMaxUtilizationInput.touched)
              "
            >
              <mat-error *ngIf="throughputMaxUtilizationInput?.errors?.required"
                >Max utilization to pass is required</mat-error
              >
              <mat-error
                *ngIf="
                  throughputMaxUtilizationInput.errors?.min ||
                  throughputMaxUtilizationInput.errors?.max
                "
              >
                Value should be 0 to 110</mat-error
              >
            </div>
          </div>
          <div class="group">
            <div class="label">Bandwidth Accuracy</div>
            <mat-select
              name="throughputBandwidth"
              class="option-list width-75"
              #throughputBandwidthInput="ngModel"
              [(ngModel)]="setupFormField.throughputBandwidth"
              (selectionChange)="throughputBandwidthChange()"
            >
              <mat-option *ngFor="let option of bandwidthAccuracy" [value]="option">
                {{ option }}</mat-option
              >
            </mat-select>
            <spa class="unit-label vert-text-mid">% </spa>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="section-label">Latency / FDV</div>
      <div class="enable-section">
        <div class="slide-btn">
          <mat-slide-toggle
            #latencyToggleElement
            name="latency"
            [checked]="setupFormField.latency"
            class="enable-row"
            color="primary"
            (change)="latencyToggleChange(latencyToggleElement)"
          >
          </mat-slide-toggle>
          <div class="toggle-text">
            <div class="section-label">
              {{ setupFormField.latency ? 'On' : 'Off' }}
            </div>
          </div>
        </div>
        <div class="section-data" *ngIf="setupFormField.latency">
          <div class="group">
            <div class="label">Duration (5-600)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-45 float-left"
              name="latencyDuration"
              #latencyDurationInput="ngModel"
              [(ngModel)]="setupFormField.latencyDuration"
              (ngModelChange)="latencyDurationChange()"
              min="5"
              max="600"
              required
            />
            <spa class="unit-label vert-text-mid">sec/frame</spa>
            <div
              class="error clr-float"
              *ngIf="
                latencyDurationInput.invalid &&
                (latencyDurationInput.dirty || latencyDurationInput.touched)
              "
            >
              <mat-error *ngIf="latencyDurationInput?.errors?.required"
                >Duration is required</mat-error
              >
              <mat-error
                *ngIf="latencyDurationInput.errors?.min || latencyDurationInput.errors?.max"
              >
                Value should be 5 to 600</mat-error
              >
            </div>
          </div>
          <div class="group">
            <div class="label">Num of Trials (0-50)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-45 float-left"
              name="latencyNumOfTrials"
              #latencyNumOfTrialsInput="ngModel"
              [(ngModel)]="setupFormField.latencyNumOfTrials"
              (ngModelChange)="latencyNumOfTrialsChange()"
              min="0"
              max="50"
              required
            />
            <div
              class="error clr-float"
              *ngIf="
                latencyNumOfTrialsInput.invalid &&
                (latencyNumOfTrialsInput.dirty || latencyNumOfTrialsInput.touched)
              "
            >
              <mat-error *ngIf="latencyNumOfTrialsInput?.errors?.required"
                >Number of trials is required</mat-error
              >
              <mat-error
                *ngIf="latencyNumOfTrialsInput.errors?.min || latencyNumOfTrialsInput.errors?.max"
              >
                Value should be 0 to 50</mat-error
              >
            </div>
          </div>
          <div class="group">
            <div class="label">Target Latency</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-100 float-left"
              name="targetLatency"
              #targetLatencyInput="ngModel"
              [(ngModel)]="setupFormField.targetLatency"
              (ngModelChange)="targetLatencyChange()"
              min="0"
              max="60000000"
              required
            />
            <spa class="unit-label vert-text-mid">usec</spa>
            <div
              class="error clr-float"
              *ngIf="
                targetLatencyInput.invalid &&
                (targetLatencyInput.dirty || targetLatencyInput.touched)
              "
            >
              <mat-error *ngIf="targetLatencyInput?.errors?.required"
                >Target latency is required</mat-error
              >
              <mat-error *ngIf="targetLatencyInput.errors?.min || targetLatencyInput.errors?.max">
                Value should be 0 to 60000000</mat-error
              >
            </div>
          </div>
          <div class="group">
            <div class="label">Target FDV</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-100 float-left"
              name="targetFdv"
              #targetFdvInput="ngModel"
              [(ngModel)]="setupFormField.targetFdv"
              (ngModelChange)="targetFdvChange()"
              min="1"
              max="60000000"
              required
            />
            <spa class="unit-label vert-text-mid">usec</spa>
            <div
              class="error clr-float"
              *ngIf="targetFdvInput.invalid && (targetFdvInput.dirty || targetFdvInput.touched)"
            >
              <mat-error *ngIf="targetFdvInput?.errors?.required"
                >Target latency is required</mat-error
              >
              <mat-error *ngIf="targetFdvInput.errors?.min || targetFdvInput.errors?.max">
                Value should be 1 to 60000000</mat-error
              >
            </div>
          </div>
          <div class="group" *ngIf="isAdvancedSetup">
            <div class="label">Utilization per Frame Size (1-100)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-45 float-left"
              name="latencyUtilization"
              #latencyUtilizationInput="ngModel"
              [(ngModel)]="setupFormField.latencyUtilization"
              (ngModelChange)="latencyUtilizationChange()"
              min="1"
              max="100"
              required
            />
            <spa class="unit-label vert-text-mid">% of CIR</spa>
            <div
              class="error clr-float"
              *ngIf="
                latencyUtilizationInput.invalid &&
                (latencyUtilizationInput.dirty || latencyUtilizationInput.touched)
              "
            >
              <mat-error *ngIf="latencyUtilizationInput?.errors?.required"
                >Utilization per Frame Size is required</mat-error
              >
              <mat-error
                *ngIf="latencyUtilizationInput.errors?.min || latencyUtilizationInput.errors?.max"
              >
                Value should be 1 to 1000</mat-error
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="section-label">Frame Loss</div>
      <div class="enable-section">
        <div class="slide-btn">
          <mat-slide-toggle
            #frameLossToggleElement
            name="frameLoss"
            [checked]="setupFormField.frameLoss"
            class="enable-row"
            color="primary"
            (change)="frameLossToggleChange(frameLossToggleElement)"
          >
          </mat-slide-toggle>
          <div class="toggle-text">
            <div class="section-label">
              {{ setupFormField.frameLoss ? 'On' : 'Off' }}
            </div>
          </div>
        </div>
        <div class="section-data" *ngIf="setupFormField.frameLoss">
          <div class="group">
            <div class="label">Duration (5-600)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-45 float-left"
              name="frameLossDuration"
              #frameLossDurationInput="ngModel"
              [(ngModel)]="setupFormField.frameLossDuration"
              (ngModelChange)="frameLossDurationChange()"
              min="5"
              max="600"
              required
            />
            <spa class="unit-label vert-text-mid">sec/frame</spa>
            <div
              class="error clr-float"
              *ngIf="
                frameLossDurationInput.invalid &&
                (frameLossDurationInput.dirty || frameLossDurationInput.touched)
              "
            >
              <mat-error *ngIf="frameLossDurationInput?.errors?.required"
                >Duration is required</mat-error
              >
              <mat-error
                *ngIf="frameLossDurationInput.errors?.min || frameLossDurationInput.errors?.max"
              >
                Value should be 5 to 600</mat-error
              >
            </div>
          </div>
          <div class="group">
            <div class="label">Max Loss Allowed (0-20)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-45 float-left"
              name="frameLossMaxLossAllowed"
              #frameLossMaxLossAllowedInput="ngModel"
              [(ngModel)]="setupFormField.frameLossMaxLossAllowed"
              (ngModelChange)="frameLossMaxLossAllowedChange()"
              min="0"
              max="20"
              required
            />
            <spa class="unit-label vert-text-mid">%</spa>
            <div
              class="error clr-float"
              *ngIf="
                frameLossMaxLossAllowedInput.invalid &&
                (frameLossMaxLossAllowedInput.dirty || frameLossMaxLossAllowedInput.touched)
              "
            >
              <mat-error *ngIf="frameLossMaxLossAllowedInput?.errors?.required"
                >Max loss allowed is required</mat-error
              >
              <mat-error
                *ngIf="
                  frameLossMaxLossAllowedInput.errors?.min ||
                  frameLossMaxLossAllowedInput.errors?.max
                "
              >
                Value should be 0 to 20</mat-error
              >
            </div>
          </div>
          <div class="group">
            <div class="label">Only Run if Throughput Test Fails</div>
            <mat-select
              class="option-list width-75"
              #frameLossRunThroughputFailsInput="ngModel"
              [(ngModel)]="setupFormField.frameLossRunThroughputFails"
              name="frameLossRunThroughputFails"
              (selectionChange)="frameLossRunThroughputFailsChange()"
              required
            >
              <mat-option
                *ngFor="let item of frameLossRunThroughputTestFailsTypes"
                [value]="item.value"
                >{{ item.name }}</mat-option
              >
            </mat-select>
          </div>
          <div class="group" *ngIf="isAdvancedSetup">
            <div class="label">Reduce Utilization between unsuccessful trials (1-10)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-45 float-left"
              name="frameLossReduceUtilization"
              #frameLossReduceUtilizationInput="ngModel"
              [(ngModel)]="setupFormField.frameLossReduceUtilization"
              (ngModelChange)="frameLossReduceUtilizationChange()"
              min="1"
              max="10"
              required
            />
            <spa class="unit-label vert-text-mid">% of CIR</spa>
            <div
              class="error clr-float"
              *ngIf="
                frameLossReduceUtilizationInput.invalid &&
                (frameLossReduceUtilizationInput.dirty || frameLossReduceUtilizationInput.touched)
              "
            >
              <mat-error *ngIf="frameLossReduceUtilizationInput?.errors?.required"
                >Reduce utilization between unsuccessful trials is required</mat-error
              >
              <mat-error
                *ngIf="
                  frameLossReduceUtilizationInput.errors?.min ||
                  frameLossReduceUtilizationInput.errors?.max
                "
              >
                Value should be 1 to 10</mat-error
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container">
      <div class="section-label">Back to Back/CBS</div>
      <div class="enable-section">
        <div class="slide-btn">
          <mat-slide-toggle
            #backToBackToggleElement
            name="backToBack"
            [checked]="setupFormField.backToBack"
            class="enable-row"
            color="primary"
            (change)="backToBackToggleChange(backToBackToggleElement)"
          >
          </mat-slide-toggle>
          <div class="toggle-text">
            <div class="section-label">
              {{ setupFormField.backToBack ? 'On' : 'Off' }}
            </div>
          </div>
        </div>
        <div class="section-data" *ngIf="setupFormField.backToBack">
          <div class="group">
            <div class="label">Test Type</div>
            <mat-select
              name="backToBackTestType"
              class="option-list width-200"
              #testTypeInput="ngModel"
              [(ngModel)]="setupFormField.backToBackTestType"
              (selectionChange)="backToBackTestTypeChange()"
            >
              <mat-option *ngFor="let test of backToBackTestTypes" [value]="test.value">
                {{ test.name }}</mat-option
              >
            </mat-select>
          </div>
          <div class="group">
            <div class="label">Max Line Rate</div>
            <mat-select
              name="backToBackMaxLineRate"
              class="option-list width-200"
              #maxLineRateInput="ngModel"
              [(ngModel)]="setupFormField.backToBackMaxLineRate"
              (selectionChange)="backToBackMaxLineRateChange()"
            >
              <mat-option *ngFor="let option of maxLineRateList" [value]="option.value">
                {{ option.name }}</mat-option
              >
            </mat-select>
            <div class="error clr-float" *ngIf="isB2bMaxLineRateValid">
              <mat-error *ngIf="isB2bMaxLineRateValid"
                >Maximum line rate cannot be less than the Subscriber Rate/CIR</mat-error
              >
            </div>
          </div>
          <div class="group">
            <div class="label">Repetitions (1-100)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-45 float-left"
              name="backToBackRepetitions"
              #backToBackRepetitionsInput="ngModel"
              [(ngModel)]="setupFormField.backToBackRepetitions"
              (ngModelChange)="backToBackRepetitionsChange()"
              min="1"
              max="100"
              required
            />
            <spa class="unit-label vert-text-mid">per frame</spa>
            <div
              class="error clr-float"
              *ngIf="
                backToBackRepetitionsInput.invalid &&
                (backToBackRepetitionsInput.dirty || backToBackRepetitionsInput.touched)
              "
            >
              <mat-error *ngIf="backToBackRepetitionsInput?.errors?.required"
                >Repetitions are required</mat-error
              >
              <mat-error
                *ngIf="
                  backToBackRepetitionsInput.errors?.min || backToBackRepetitionsInput.errors?.max
                "
              >
                Value should be 1 to 100</mat-error
              >
            </div>
          </div>
          <div class="group" *ngIf="setupFormField.backToBackTestType === 'b2b'">
            <div class="label">Target Burst Duration (2-30)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-45 float-left"
              name="backToBackTargetBurstDuration"
              #backToBackTargetBurstDurationInput="ngModel"
              [(ngModel)]="setupFormField.backToBackTargetBurstDuration"
              (ngModelChange)="backToBackTargetBurstDurationChange()"
              min="2"
              max="30"
              required
            />
            <spa class="unit-label vert-text-mid">usec</spa>
            <div
              class="error clr-float"
              *ngIf="
                backToBackTargetBurstDurationInput.invalid &&
                (backToBackTargetBurstDurationInput.dirty ||
                  backToBackTargetBurstDurationInput.touched)
              "
            >
              <mat-error *ngIf="backToBackTargetBurstDurationInput?.errors?.required"
                >Target burst duration is required</mat-error
              >
              <mat-error
                *ngIf="
                  backToBackTargetBurstDurationInput.errors?.min ||
                  backToBackTargetBurstDurationInput.errors?.max
                "
              >
                Value should be 2 to 30</mat-error
              >
            </div>
          </div>
          <div class="group" *ngIf="setupFormField.backToBackTestType === 'cbs'">
            <div class="label">Committed Burst Size (1-1024)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-45 float-left"
              name="cbsCommittedBurstSize"
              #cbsCommittedBurstSizeInput="ngModel"
              [(ngModel)]="setupFormField.cbsCommittedBurstSize"
              (ngModelChange)="cbsCommittedBurstSizeChange()"
              min="1"
              max="1024"
              required
            />
            <spa class="unit-label vert-text-mid">Kbytes</spa>
            <div
              class="error clr-float"
              *ngIf="
                cbsCommittedBurstSizeInput.invalid &&
                (cbsCommittedBurstSizeInput.dirty || cbsCommittedBurstSizeInput.touched)
              "
            >
              <mat-error *ngIf="cbsCommittedBurstSizeInput?.errors?.required"
                >Committed burst size is required</mat-error
              >
              <mat-error
                *ngIf="
                  cbsCommittedBurstSizeInput.errors?.min || cbsCommittedBurstSizeInput.errors?.max
                "
              >
                Value should be 1 to 1024</mat-error
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container" *ngIf="setupFormField.backToBack && isAdvancedSetup">
      <div class="section-label"></div>
      <div class="enable-section">
        <div class="section-data">
          <div class="group" *ngIf="setupFormField.backToBackTestType === 'b2b'">
            <div class="label">Burst Resolution (1-1000)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-50 float-left"
              name="backToBackBurstResolution"
              #backToBackBurstResolutionInput="ngModel"
              [(ngModel)]="setupFormField.backToBackBurstResolution"
              (ngModelChange)="backToBackBurstResolutionChange()"
              min="1"
              max="1000"
              required
            />
            <spa class="unit-label vert-text-mid">frames</spa>
            <div
              class="error clr-float"
              *ngIf="
                backToBackBurstResolutionInput.invalid &&
                (backToBackBurstResolutionInput.dirty || backToBackBurstResolutionInput.touched)
              "
            >
              <mat-error *ngIf="backToBackBurstResolutionInput?.errors?.required"
                >Burst resolution is required</mat-error
              >
              <mat-error
                *ngIf="
                  backToBackBurstResolutionInput.errors?.min ||
                  backToBackBurstResolutionInput.errors?.max
                "
              >
                Value should be 1 to 1000</mat-error
              >
            </div>
          </div>
          <div class="group" *ngIf="setupFormField.backToBackTestType === 'b2b'">
            <div class="label">Max Time to Receive Burst (2-60 sec, 0 = don't care)</div>
            <input
              matInput
              autocomplete="off"
              type="number"
              class="input-data width-60 float-left"
              name="backToBackMaxTimeReceiveBurst"
              #backToBackMaxTimeReceiveBurstInput="ngModel"
              [(ngModel)]="setupFormField.backToBackMaxTimeReceiveBurst"
              (ngModelChange)="backToBackMaxTimeReceiveBurstChange()"
              min="0"
              max="60"
              required
            />
            <spa class="unit-label vert-text-mid">sec</spa>
            <div
              class="error clr-float"
              *ngIf="
                backToBackMaxTimeReceiveBurstInput.invalid &&
                (backToBackMaxTimeReceiveBurstInput.dirty ||
                  backToBackMaxTimeReceiveBurstInput.touched)
              "
            >
              <mat-error *ngIf="backToBackMaxTimeReceiveBurstInput?.errors?.required"
                >Max time to receive burst is required</mat-error
              >
              <mat-error
                *ngIf="
                  backToBackMaxTimeReceiveBurstInput.errors?.min ||
                  backToBackMaxTimeReceiveBurstInput.errors?.max
                "
              >
                Value should be 0 to 60</mat-error
              >
            </div>
          </div>
          <div class="group" *ngIf="setupFormField.backToBackTestType === 'cbs'">
            <div class="label">KiloByte Size</div>
            <mat-select
              name="cbsKiloByteSize"
              class="option-list width-200"
              #cbsKiloByteSizeInput="ngModel"
              [(ngModel)]="setupFormField.cbsKiloByteSize"
              (selectionChange)="cbsKiloByteSizeChange()"
            >
              <mat-option *ngFor="let test of cbsKiloByteSizeTypes" [value]="test.value">
                {{ test.name }}</mat-option
              >
            </mat-select>
          </div>
        </div>
      </div>
    </div>
    <div class="section-container height-120" *ngIf="!isDisabledScheduler">
      <div class="section-label"><label>Schedule</label></div>
      <div class="scheduler-section">
        <viavi-scheduler
          [scheduleValue]="scheduleInfoData"
          (schedulerDataVal)="fetchSchedulerVal($event)"
          [isDisabledScheduler]="isDisabledScheduler"
          [schedulerEnds]="schedulerEnds"
        >
        </viavi-scheduler>
      </div>
    </div>
  </div>
</form>
